<template>
  <div class="w-full page-heading" v-if="!isPreview">
    <quill-editor
      :value="title"
      :options="getQuillEditorOptions('page-heading')"
      @change="updateTitle($event)"
      @ready="onEditorReady($event)"
    ></quill-editor>
  </div>
  <div class="w-full page-heading" v-else v-html="title"></div>
</template>
<script>
import quillMixin from '../../../mixins/quill';

export default {
  name: 'Title',
  mixins: [quillMixin],
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    text: {
      type: String,
      required: true,
    },
    updateTitle: {
      type: Function,
      required: true,
    },
  },
  computed: {
    title() {
      return this.text;
    },
  },
  methods: {},
  watch: {},
};
</script>
